import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { Paper } from '@mui/material';
import { Button } from '@mui/material';

import settings from '../../settings/settings';

import './Tutorial.scss';

function Tutorial() {
  const navigate = useNavigate();

  const carouselSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const slide1P1URL = `${settings.BASE_PATH_IMAGES_FOLDER}/img-map.png`;
  const slide1P2URL = `${settings.BASE_PATH_IMAGES_FOLDER}/img-agent-solving-focus.png`;
  const slide2URL = `${settings.BASE_PATH_IMAGES_FOLDER}/img-onboarding-2.png`;
  const slide3URL = `${settings.BASE_PATH_IMAGES_FOLDER}/img-onboarding-3.png`;
  const slide4URL = `${settings.BASE_PATH_IMAGES_FOLDER}/img-onboarding-4.png`;

  function handleClickStart() {
    navigate('/login');
  }

  return (
    <div className="outter-page tutorial-page">
      <div className="outter-page-content-container">
        <Slider {...carouselSettings}>
          <Paper elevation={2} className="paper" >
            <img src={slide1P1URL} alt="Slide 1" className="slide-1-p1" />
            <img src={slide1P2URL} alt="Slide 1" className="slide-1-p2" />
            <h3 className="slide-message s1">Monitore focos de vetores</h3>
          </Paper>
          <Paper elevation={2} className="paper" >
            <img src={slide2URL} alt="Slide 2" />
            <h3 className="slide-message">Investigue denúncias</h3>
          </Paper>
          <Paper elevation={2} className="paper" >
            <img src={slide3URL} alt="Slide 3" />
            <h3 className="slide-message">Fique de olho na sua área de trabalho</h3>
          </Paper>
          <Paper elevation={2} className="paper" >
            <img src={slide4URL} alt="Slide 4" />
            <h3 className="slide-message s3">E contribua para a saúde<br/>de sua cidade!</h3>
            <Button
              className="btn-start s3"
              onClick={handleClickStart}>Começar</Button>
          </Paper>
        </Slider>
      </div>
    </div>
  );
}

export default Tutorial;
